module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<cam-context-switcher-menu-list\n  id="cam-context-switcher-organization-menu-list"\n  class="cam-context-switcher-panel-column menu"\n  data-type="organization"\n  data-title="Organizations"\n>\n</cam-context-switcher-menu-list>\n<cam-context-switcher-card-list\n  id="cam-context-switcher-costcenter-card-list"\n  class="cam-context-switcher-panel-column content"\n  data-type="costcenter"\n  data-title="Cost Centers"\n>\n</cam-context-switcher-card-list>\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<cam-context-switcher-menu-list\n  id="cam-context-switcher-organization-menu-list"\n  class="cam-context-switcher-panel-column menu"\n  data-type="organization"\n  data-title="Organizations"\n>\n</cam-context-switcher-menu-list>\n<cam-context-switcher-card-list\n  id="cam-context-switcher-costcenter-card-list"\n  class="cam-context-switcher-panel-column content"\n  data-type="costcenter"\n  data-title="Cost Centers"\n>\n</cam-context-switcher-card-list>\n');
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/cam-context-switcher/templates/cam-context-switcher-tab-costcenters.ejs
// module id = 131
// module chunks = 0 1